"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createRoles = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var createRoles = function createRoles(userRoles) {
  return userRoles && userRoles.reduce(function (set, role) {
    var roles = role.roleId.permissions;
    set.add.apply(set, (0, _toConsumableArray2["default"])(roles));
    return set;
  }, new Set());
};

exports.createRoles = createRoles;